import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './style.module.css'
import { UploadFileAndList, IndirectPaymentUpload } from '../../../Components'
import ImportFlowModal from '../../../Components/ImportFlowModal'
import exampleFile from './exampleimportacao.xlsx'
import bulkExampleFile from './examplepagamentoindireto.xlsx'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import HeaderInternal from '../../../Components/HeaderInternal';
import { getFeatureFlags } from '../../../services/kollectaApi';

const INDIRECT_PAYMENT_IMPORT_KEY = 'indirect_payment_import';

const PastDue = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isBulkUploadScreen = pathname.includes('/past-due/import/bulk');
  const isUploadScreen = pathname.includes('/past-due/import') && !isBulkUploadScreen;
  const [hasIndirectPaymentImport, setHasIndirectPaymentImport] = useState(false);
  const [isImportFlowOpen, setIsImportFlowOpen] = useState(false);

  useEffect(() => {
    const loadFeatureFlags = async () => {
      try {
        const response = await getFeatureFlags();
        const flags = response?.data?.featureFlags || [];
        const enabled = flags.some(
          (flag) => flag.key === INDIRECT_PAYMENT_IMPORT_KEY && flag.enabled
        );
        setHasIndirectPaymentImport(enabled);
      } catch (error) {
        setHasIndirectPaymentImport(false);
      }
    };

    loadFeatureFlags();
  }, []);

  return (
    <div className={styles.container}>
      <ReactCSSTransitionGroup transitionName="anim"
        transitionAppear={true}
        transitionAppearTimeout={500}
        transitionEnter={false}
        transitionLeave={false}>
        <section>
          <HeaderInternal title="Upload de arquivo" bold={true} />
          <div className={styles.paddingContent}>
            <h2 className={styles.sectionTitle}>Importação de dados</h2>
            {isUploadScreen && (
              <UploadFileAndList showList exampleFile={exampleFile} />
            )}
            {isBulkUploadScreen && (
              <IndirectPaymentUpload exampleFile={bulkExampleFile} />
            )}
            {!isUploadScreen && !isBulkUploadScreen && (
              <button
                type="button"
                className={styles.startImportButton}
                onClick={() => setIsImportFlowOpen(true)}
              >
                Iniciar importação
              </button>
            )}
          </div>
        </section>
      </ReactCSSTransitionGroup>
      {isImportFlowOpen && (
        <ImportFlowModal
          showBulkOption={hasIndirectPaymentImport}
          newBaseExample={exampleFile}
          bulkExample={bulkExampleFile}
          onClose={() => setIsImportFlowOpen(false)}
          onContinueNewBase={() => {
            setIsImportFlowOpen(false);
            navigate('/dashboard/past-due/import');
          }}
          onContinueBulk={() => {
            setIsImportFlowOpen(false);
            navigate('/dashboard/past-due/import/bulk');
          }}
        />
      )}
    </div>
  )
}

export default PastDue
